import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'visualizeSpaces',
  standalone: true,
})
export class visualizeSpacePipe implements PipeTransform {
  transform(value: string): string {
    return value ? value.replaceAll(' ', '·').replace('&nbsp;', '·') : '';
  }
}
